<script>
    import FieldError  from '../../../shared/FieldError.svelte'
    import Shared      from './Shared.svelte'

    export let domain
    export let place
    export let active

    const constraints = {
        url: {
            presence: {
                allowEmpty: false,
                message: "campo obrigatório"
            },
            url: {
                message: "url inválida"
            }
        },
    }

    let config = {
        kind    : 'api',
        url     : active && active.url    || '',
        header  : active && active.header || '',
        token   : active && active.token  || ''
    }

</script>
<Shared type="api" {domain} {place} {config} {constraints} let:working let:errors>
    <div class="field" 
         class:disabled={working}
         class:error={errors.url}>
        <label>Url</label>
        <input bind:value={config.url}>
        <FieldError style="label" property={errors.url} />
    </div>
    <div class="field" class:disabled={working}>
        <label>Header</label>
        <input bind:value={config.header}>
    </div>
    <div class="field" class:disabled={working}>
        <label>Token</label>
        <input bind:value={config.token}>
    </div>
</Shared>

